export default __webpack_public_path__ + "_/images/marketplace/slot-helmet-8c9213612e25dc87cec5d7221e2e83f669d585fc54a8cec1939529d875f939b3.png";